import {useFetch} from "../useFetch";
import {TypeContainer} from "../../types/api/guide/typeСontainer.types";
import {typeContainerService} from "../../services/guide/typeContainer-service";

export const useFetchGetTypeContainerById = (id?: string) => {

    const { isLoading, error, data } =
        useFetch<TypeContainer>(
            typeContainerService.getById,
            [id],
            { enabled: Boolean(id) });

    return { data: data as TypeContainer, isLoading, error };
}